import React from "react";

export default function ProfileImage({ image }: { image: string }) {
  return (
    <figure className="image is-180x180 profile-container is-overlay">
      <img className="is-rounded profile-image" src={image} alt="Profile" />
    </figure>
  );
}
